__turbopack_context__.v({
  "app_light_theme": "CardNotification-module-scss-module__KGPyGW__app_light_theme",
  "cardNotification": "CardNotification-module-scss-module__KGPyGW__cardNotification",
  "cardNotification__arrowPrefix": "CardNotification-module-scss-module__KGPyGW__cardNotification__arrowPrefix",
  "cardNotification__tip": "CardNotification-module-scss-module__KGPyGW__cardNotification__tip",
  "cardNotification_disabled": "CardNotification-module-scss-module__KGPyGW__cardNotification_disabled",
  "cardNotification_withPointer": "CardNotification-module-scss-module__KGPyGW__cardNotification_withPointer",
});
